/**
 * API client: Novidades (feature spotlight), lado de quem usa o produto.
 *
 * Rotas em /api/feature-spotlights (requireAuth). As rotas de admin vivem em
 * /api/internal/feature-spotlights e ficam em outro módulo.
 */

import { authFetch } from '@/utils/api';

const USER_BASE = '/api/feature-spotlights';

async function parse(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || data.message || 'Erro na requisição');
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

const post = (id, action) =>
    authFetch(`${USER_BASE}/${encodeURIComponent(id)}/${action}`, { method: 'POST', body: JSON.stringify({}) }).then(parse);

/** @returns {Promise<{ cards: object[], pointers: object[] }>} */
export async function getCandidates() {
    return parse(await authFetch(`${USER_BASE}/candidates`));
}

/** Idempotente: grava `firstSeenAt` uma única vez. */
export const markSpotlightSeen = (id) => post(id, 'seen');

export const dismissSpotlight = (id) => post(id, 'dismiss');

/** O ponteiro apareceu na tela (idempotente). */
export const markPointerShown = (id) => post(id, 'pointer-shown');

/** @param {"used"|"acknowledged"} outcome o primeiro desfecho gravado vence */
export const completePointer = (id, outcome) =>
    authFetch(`${USER_BASE}/${encodeURIComponent(id)}/pointer-done`, { method: 'POST', body: JSON.stringify({ outcome }) }).then(parse);

/** @returns {Promise<{ resolution: string, destination: { kind: string, value: string|null, anchorNavKey: string, targetKey: string|null } }>} */
export const trySpotlight = (id) => post(id, 'try');

export default {
    getCandidates,
    markSpotlightSeen,
    dismissSpotlight,
    trySpotlight,
    markPointerShown,
    completePointer,
};
